import $ from 'jquery';

/**
 * The accordion logic for the content filters.
 */
const initFilterAccordion = () => {
	const filtersTitle = $('.em-filterable-content__title');
	if (filtersTitle.length > 0) {
		filtersTitle.click(function () {
			const filters = $(this).parent().find('.em-filterable-content__accordion');
			$(this).toggleClass('active');
			filters.slideToggle('slow');
		});
	}
};

export default initFilterAccordion;
